module.exports = __webpack_public_path__ + "static/media/rooms.4282ecb4.svg";